import actionTypes from 'SRC/modules/redux/actionTypes'

export const setSimilarWords = (similarWords) => ({
  type: actionTypes.SET_SIMILAR_WORDS,
  payload: similarWords
})
